import { render, staticRenderFns } from "./EchartChina.vue?vue&type=template&id=5ab72c1a&scoped=true"
import script from "./EchartChina.vue?vue&type=script&lang=js"
export * from "./EchartChina.vue?vue&type=script&lang=js"
import style0 from "./EchartChina.vue?vue&type=style&index=0&id=5ab72c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab72c1a",
  null
  
)

export default component.exports